export default {
    namespaced: true,
    state: {
        allSelected: false,
        totalCount: 0, // all existing items (for pagination, filters etc)
        uncheckedItems: [],
        checkedItems: [],
        displayItems: [], // currently displayed items to perform checking
        allDisplayItemsSelected: false
    },
    getters: {
        selectedCount: (state, a) => {
            const items = (state.allSelected ? state.uncheckedItems : state.checkedItems).filter(item => !item.disabled);
            return state.allSelected ? state.totalCount - items.length : items.length;
        },
        selectedIds: (state) => {
            return (property) => {
                let items = state.allSelected ? state.uncheckedItems : state.checkedItems;
                return items.filter(item => !item.disabled).map(item => item[property || 'id']);
            }
        }
    },
    mutations: {
        itemCheckChange: (state, item) => {
            _onItemCheckChange(state, item);
        },
        columnCheckChange: (state, items) => {
            state.allDisplayItemsSelected = !state.allDisplayItemsSelected;
            state.displayItems = _getSelectedForDisplayItems(state.allDisplayItemsSelected, state.displayItems);
    
            items.forEach(item => {
                _onItemCheckChange(state, item);
            });
        },
        selectAll: (state) => {
            _onAllSelectedCheckChange(true, state);
        },
        clearAll: (state) => {
            _onAllSelectedCheckChange(false, state);
        },
        initDisplayItems: (state, [newItems, totalCount]) => {
            state.displayItems = newItems;
            state.totalCount = totalCount;
            _performChecking(state);
            state.allDisplayItemsSelected = _areAllDisplayItemsSelected(state.displayItems);
        },
        restoreDefaults: (state) => {
            state.allSelected = false;
            state.totalCount = 0;
            state.uncheckedItems = [];
            state.checkedItems = [];
            state.displayItems = [];
            state.allDisplayItemsSelected = false;
        }
    }
};

function _addItem(collection, item) {
    if (collection.find(element => element.id === item.id) || item.disabled) {
        return;
    }
    collection.push({id: item.id});
}

function _removeItem(collection, item) {
    const foundedElement = collection.find(element => element.id === item.id);
    collection.splice(collection.indexOf(foundedElement), 1);
}
function _areAllDisplayItemsSelected(displayItems) {
    return displayItems.every(item => item.selected);
}

function _onAllSelectedItemCheckChange(item, uncheckedItems) {
    if (item.selected) {
        _removeItem(uncheckedItems, item);
    } else {
        _addItem(uncheckedItems, item);
    }
}

function _onNotAllSelectedItemCheckChange(item, checkedItems) {
    if (item.selected) {
        _addItem(checkedItems, item);
    } else {
        _removeItem(checkedItems, item);
    }
}

function _onItemCheckChange(state, item) {
    if (state.allSelected) {
        _onAllSelectedItemCheckChange(item, state.uncheckedItems);
    } else {
        _onNotAllSelectedItemCheckChange(item, state.checkedItems);
    }
    
    state.allDisplayItemsSelected = _areAllDisplayItemsSelected(state.displayItems);
}

function _getSelectedForDisplayItems(selected, displayItems) {
    return displayItems.map(item => {
        if (!item.disabled) {
            item.selected = selected;
        }
        return item;
    });
}
function _onAllSelectedCheckChange(value, state) {
    state.allSelected = value;
    state.uncheckedItems = [];
    state.checkedItems = [];
    state.displayItems = _getSelectedForDisplayItems(state.allSelected, state.displayItems);
    state.allDisplayItemsSelected = _areAllDisplayItemsSelected(state.displayItems);
}

/* this process verifying whether among new display items those who were in checked/unckecked collections.
        using this process we storing all checks made by user and displaying always actual state.
     */
function _performChecking(state) {
    state.displayItems.forEach(item => {
        item.selected = !item.disabled && state.allSelected ? !state.uncheckedItems.find(element => element.id === item.id) :
            !!state.checkedItems.find(element => element.id === item.id);
    });
}